import React from 'react';

import MuiDivider, {
  DividerProps as MuiDividerProps,
} from '@mui/material/Divider';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Divider = withCoreProps<DividerProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<DividerProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiDivider {...props} className={clsxClass}>
        {children}
      </MuiDivider>
    );
  },
);

export interface DividerProps extends MuiDividerProps, CoreProps {}
